import {
  AccountInput,
  Maybe,
  SubscriptionInput,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { sponsorFragmentString } from '../../fragments/__generated__/SponsorFragment'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import updateAccountRawString from '../UpdateAccount.graphql'

const updateAccountString = [
  updateAccountRawString,
  accountFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
  stripeSubscriptionString,
  sponsorFragmentString,
  subscriptionMetadataString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  userSettingsFragmentString,
  expenseReloadString,
  bankAccountFragmentString,
  addressFragmentString,
].join('\n\n')

export type UpdateAccountData = {
  updateAccount: {
    account: AccountFragment
  }
}

export type UpdateAccountVariables = {
  account: AccountInput
  subscription?: Maybe<SubscriptionInput>
}

export type UpdateAccount = Operation<UpdateAccountData, UpdateAccountVariables>

export const UpdateAccount = ({
  account,
  subscription,
}: UpdateAccountVariables): UpdateAccount => ({
  query: updateAccountString,
  variables: {
    account: AccountInput(account),
    subscription: subscription && SubscriptionInput(subscription),
  },
})
